import store from '@/store/index'

export default function setup() {
  try{
    store.dispatch('api/setUpInterceptors')
  }catch(e){
    console.log(e);
  }
}